/**
 * Privacy Meta Configuration
 * Provides standardized privacy meta tags for SEO blocking and crawler prevention
 */

export const PRIVACY_META_TAGS = {
  // Core privacy directives
  robots: 'noindex, nofollow, noarchive, nosnippet, noimageindex',
  
  // Search engine specific directives
  googlebot: 'noindex, nofollow, noarchive, nosnippet',
  bingbot: 'noindex, nofollow, noarchive, nosnippet',
  slurp: 'noindex, nofollow, noarchive, nosnippet',
  duckduckbot: 'noindex, nofollow, noarchive, nosnippet',
  
  // Social media blocking
  'twitter:robots': 'noindex'
};

/**
 * Apply privacy meta tags to document head
 * Used for client-side route changes
 */
export function applyPrivacyMetaTags() {
  Object.entries(PRIVACY_META_TAGS).forEach(([name, content]) => {
    // Remove existing meta tag if present
    const existing = document.querySelector(`meta[name="${name}"]`);
    if (existing) {
      existing.remove();
    }
    
    // Create and add new meta tag
    const meta = document.createElement('meta');
    meta.name = name;
    meta.content = content;
    document.head.appendChild(meta);
  });
}

/**
 * Remove any social media meta tags that might leak information
 */
export function removeSocialMediaTags() {
  const socialTags = [
    'og:title',
    'og:description', 
    'og:image',
    'og:url',
    'og:type',
    'og:site_name',
    'twitter:card',
    'twitter:title',
    'twitter:description',
    'twitter:image',
    'twitter:site',
    'twitter:creator'
  ];
  
  socialTags.forEach(tagName => {
    const existing = document.querySelector(`meta[property="${tagName}"], meta[name="${tagName}"]`);
    if (existing) {
      existing.remove();
    }
  });
}